import { useGetFeatures } from 'api/generated/feature-controller/feature-controller';

export const useRemoteFeatureFlags = (oktaUserId: string | undefined) =>
  useGetFeatures(oktaUserId ?? '', {
    query: { enabled: !!oktaUserId },
  });
